import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function AddPhotoAlternate(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14l4-4h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 14l2.03-2.71 2.71 3.62L15 11l4 6H8z" />
    </SvgIcon>
  )
}
